module.exports = [
  { code: 11, name: 'Network Device Detection' },
  { code: 12, name: 'AutoPing Timeout' },
  { code: 13, name: 'Inlet Line Max Current Threshold' },
  { code: 14, name: 'Inlet Line Min Current Threshold' },
  { code: 15, name: 'Inlet Max Current Threshold' },
  { code: 16, name: 'Inlet Min Current Threshold' },
  { code: 17, name: 'Inlet Max Voltage RMS Threshold' },
  { code: 18, name: 'Inlet Min Voltage RMS Threshold' },
  { code: 19, name: 'Inlet Max Line Frequency Threshold' },
  { code: 20, name: 'Inlet Min Line Frequency Threshold' },
  { code: 21, name: 'Inlet Min Power Factor' },
  { code: 22, name: 'Inlet Active Energy Accumulation Max' },
  { code: 23, name: 'Inlet Max Active Power Threshold' },
  { code: 24, name: 'Inlet Min Active Power Threshold' },
  { code: 25, name: 'Inlet Max Apparent Power Threshold' },
  { code: 26, name: 'Inlet Min Apparent Power Threshold' },
  { code: 30, name: 'Bank Circuit Breaker Trip' },
  { code: 31, name: 'Bank Max Current Threshold' },
  { code: 32, name: 'Bank Min Current Threshold' },
  { code: 33, name: 'Bank Max Voltage RMS Threshold' },
  { code: 34, name: 'Bank Min Voltage RMS Threshold' },
  { code: 35, name: 'Bank Max Line Frequency Threshold' },
  { code: 36, name: 'Bank Min Line Frequency Threshold' },
  { code: 37, name: 'Bank Min Power Factor' },
  { code: 38, name: 'Bank Active Energy Accumulation Max' },
  { code: 39, name: 'Bank Max Active Power Threshold' },
  { code: 40, name: 'Bank Min Active Power Threshold' },
  { code: 41, name: 'Bank Max Apparent Power Threshold' },
  { code: 42, name: 'Bank Min Apparent Power Threshold' },
  { code: 45, name: 'Outlet Max Current Threshold' },
  { code: 46, name: 'Outlet Min Current Threshold' },
  { code: 47, name: 'Group Max Current Threshold' },
  { code: 48, name: 'Group Min Current Threshold' },
  { code: 49, name: 'Temperature Max Threshold' },
  { code: 50, name: 'Temperature Min Threshold' },
  { code: 51, name: 'Humidity Max Threshold' },
  { code: 52, name: 'Humidity Min Threshold' },
  { code: 53, name: 'Daily Time to Trigger' },
  { code: 54, name: 'Time Interval Between Triggers' },
  { code: 55, name: 'ATS Switched to Secondary' },
  { code: 56, name: 'ATS Switched to Primary' },
  { code: 57, name: 'Secondary Power Source Lost' },
  { code: 58, name: 'Secondary Power Source Restored' },
  { code: 59, name: 'System Power Recovery Event' },
  { code: 60, name: 'Monthly Scheduled Event' },
  { code: 61, name: 'Weekly Scheduled Event' },
  { code: 62, name: 'IO Hub Sensor Digital Input State High' },
  { code: 63, name: 'IO Hub Sensor Digital Input State Low' },
  { code: 64, name: 'IO Hub Sensor User Switch Triggered' },
  { code: 65, name: 'Sensor Connected/Disconnected' },
  { code: 66, name: 'Default Route Switched to LTE' },
  { code: 67, name: 'Default Route Switched to Ethernet' },
  { code: 1048267, name: 'Device Connection State' },
];
